module.exports = __webpack_public_path__ + "static/images/recommend-enter.661c70d.png";